/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './channel.stache';
import can from 'can';

export function shortenName(name) {
    let nameArr = name.split(' ');
    if (nameArr.length > 1) {
        nameArr[0] = `${nameArr[0].charAt(0)}.`;
        name = nameArr.join(`\u00A0`);
    }
    return name;
}

Component.extend({
    tag: 'right-rail-channel',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            isActive: {
                type: 'boolean',
                get() {
                    return (
                        this.attr('activeChannels').indexOf(
                            this.attr('data.video.identifier'),
                        ) != -1
                    );
                },
            },
            activeViewIndexes: {
                type: 'array',
                get() {
                    const activeVideo = this.attr('activeChannels');
                    const videoId = this.attr('data.video.identifier');
                    const activeVideos = (videos = []) =>
                        videos
                            .map((id, i) => (id === videoId ? i : null))
                            .filter((el) => typeof el === 'number');
                    return activeVideos(activeVideo);
                },
            },
            activeView: {
                type: 'object',
            },
            activeChannel: {
                type: 'string',
                value: null,
            },
            activeChannels: {
                Type: can.List,
                Value: can.List,
            },
            taggedPlayers: {
                get() {
                    let playerTagGroups = this.attr('data').playerTagGroups;
                    if (playerTagGroups) {
                        let taggedPlayers = [];
                        playerTagGroups.each((ptg) => {
                            ptg.each((pl) => {
                                const player = pl.attr(
                                    'shortTitle',
                                    shortenName(pl.title),
                                );
                                taggedPlayers.push(player);
                            });
                        });
                        return taggedPlayers;
                    }
                },
            },
            isModalShown: {
                type: 'boolean',
                value: false,
            },
            selectedPlayer: {
                Type: can.Map,
                value: null,
            },
            selectedPlayerFacts: {
                Type: can.List,
                Value: can.List,
            },
            taggedHoles: {
                get() {
                    let holeTags = this.attr('data').holeTags;
                    return holeTags
                        ? holeTags
                              .map((ht) => {
                                  return ht.title;
                              })
                              .join(', ')
                        : '';
                },
            },
            streamOffMessagingConfig: {
                Type: can.Map,
                Value: can.Map,
            },
            videoStreamingOn: {
                get() {
                    return this.attr('streamOffMessagingConfig')
                        .videoStreamingOn;
                },
            },
        },
        modalClosed: function() {
            this.attr('isModalShown', false);
            this.attr('selectedPlayer', null);
            this.attr('selectedPlayerFacts', null);
        },
        openModal: function($event, player) {
            const facts = player.attr('facts');
            if (facts.length) {
                $event.stopPropagation();

                this.attr('selectedPlayer', player);
                this.attr(
                    'selectedPlayerFacts',
                    facts.serialize().map((fact) => {
                        if (typeof fact === 'string') {
                            return fact;
                        } else {
                            return fact.text;
                        }
                    }),
                );
                this.attr('isModalShown', true);
            }
        },
    },
});
